// import { paginationDataToShow } from "../actions/generalActions";
import {
  STORE_CREATE_REQUEST,
  STORE_CREATE_SUCCESS,
  STORE_CREATE_FAIL,
  ALL_STORE_VIEW_REQUEST,
  ALL_STORE_VIEW_SUCCESS,
  ALL_STORE_VIEW_FAIL,
  STORE_UPDATE_REQUEST,
  STORE_UPDATE_SUCCESS,
  STORE_UPDATE_FAIL,
  ORDER_BY_ID_SUCCESS,
} from "../constants";

export const storeReducer = (
  state = {
    store: {
      store: null,
      from: null,
      to: null,
      loading: false,
    },
  },
  action
) => {
  switch (action.type) {
    case STORE_CREATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case STORE_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case STORE_CREATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // STORE VIEW TABLE
    case ALL_STORE_VIEW_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_STORE_VIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        store: action.payload,
      };
    case ALL_STORE_VIEW_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ORDER_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        storeDetails: action.payload,
      };

    // STORE UPDATE
    case STORE_UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case STORE_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        // old code hata dya
        store: state.store.map((x) =>
          x.id == action.payload.id ? action.payload : x
        ),
      };
    case STORE_UPDATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
